import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageShell from "./AdminPageShell";
import useFetch from "../../useFetch";
import { apiRequest } from "../../utils/api";
import Pagination from "../Pagination";

const AdminCandidates = () => {
  const perPage = 10;
  const [page, setPage] = useState(1);
  const [refreshKey, setRefreshKey] = useState(0);
  const [candidates, setCandidates] = useState([]);
  const [meta, setMeta] = useState({});
  const [message, setMessage] = useState(false);
  const [actionError, setActionError] = useState(false);
  const apiUrl = process.env.REACT_APP_BASE_API_URL + `/admin/candidates?per_page=${perPage}&page=${page}` + (refreshKey ? `&_=${refreshKey}` : "");
  const { response, isLoading, error } = useFetch(apiUrl);

  useEffect(() => {
    setCandidates(response?.candidates?.data ?? []);
    setMeta(response?.candidates?.meta ?? {});
  }, [response]);

  const refresh = () => setRefreshKey(Date.now());
  const referralText = (candidate) => candidate.referred_by?.epic_jobs_id
    ? `Referred by ${candidate.referred_by.epic_jobs_id} (${candidate.referred_by.name})`
    : "No referral";

  const updateStatus = (candidate, accountStatus) => {
    if (!window.confirm(`${accountStatus === "blocked" ? "Block" : "Unblock"} this candidate account?`)) return;

    setMessage(false);
    setActionError(false);
    const formData = new FormData();
    formData.append("account_status", accountStatus);

    apiRequest(`/admin/users/${candidate.id}/status`, { method: "POST", body: formData })
      .then((data) => {
        setMessage(data.message);
        refresh();
      })
      .catch((error) => setActionError(error.message));
  };

  const removeCandidate = (candidate) => {
    if (!window.confirm("Remove this candidate account? This cannot be undone.")) return;

    setMessage(false);
    setActionError(false);
    apiRequest(`/admin/users/${candidate.id}`, { method: "DELETE" })
      .then((data) => {
        setMessage(data.message);
        refresh();
      })
      .catch((error) => setActionError(error.message));
  };

  return (
    <AdminPageShell
      active="candidates"
      title="Candidates"
      text="Review candidate accounts, applications, saved jobs, and access status."
    >
      <div className="ls-widget">
        <div className="widget-title">
          <h4>Candidate Accounts</h4>
        </div>
        <div className="admin-crud-bar">
          <p>Super admin can block, unblock, or remove candidate accounts.</p>
        </div>
        <div className="widget-content">
          {message && <div className="alert alert-success"><strong>{message}</strong></div>}
          {actionError && <div className="alert alert-danger"><strong>{actionError}</strong></div>}
          {error && <div className="alert alert-danger"><strong>{error}</strong></div>}
          {isLoading && <h5 className="text-center my-3">Loading Data</h5>}
          {!error && !isLoading && meta?.total > 0 && (
            <div className="admin-list-summary">Showing {candidates.length} of {meta.total} candidates</div>
          )}
          <div className="admin-table-list">
            {!error && !isLoading && candidates.map((candidate) => (
              <div className="admin-table-row" key={candidate.id}>
                <div>
                  <strong>{candidate.name}</strong>
                  <span>{candidate.epic_jobs_id || "No Epic-Jobs ID"} - {candidate.email} - {candidate.title || "No title"} - {candidate.applications_count} applications - {candidate.saved_jobs_count} saved jobs</span>
                  <span>{referralText(candidate)}</span>
                </div>
                <div className="admin-row-actions">
                  <span className={candidate.account_status === "blocked" ? "danger" : ""}>{candidate.account_status}</span>
                  <Link to={`/admin-candidates/${candidate.id}`} className="theme-btn btn-style-three">View</Link>
                  <button type="button" className="theme-btn btn-style-danger" onClick={() => removeCandidate(candidate)}>Delete</button>
                  {candidate.account_status === "blocked" ? (
                    <button type="button" className="theme-btn btn-style-success" onClick={() => updateStatus(candidate, "active")}>Unblock</button>
                  ) : (
                    <button type="button" className="theme-btn btn-style-danger" onClick={() => updateStatus(candidate, "blocked")}>Block</button>
                  )}
                </div>
              </div>
            ))}
            {!error && !isLoading && candidates.length === 0 && <div className="admin-empty-state">No candidates found.</div>}
          </div>
          {!error && !isLoading && <Pagination meta={meta} onPageChange={setPage} label="Candidate pagination" />}
        </div>
      </div>
    </AdminPageShell>
  );
};

export default AdminCandidates;
